import { render, staticRenderFns } from "./modal-unavailable-ingredients.vue?vue&type=template&id=82b40832&"
import script from "./modal-unavailable-ingredients.vue?vue&type=script&lang=js&"
export * from "./modal-unavailable-ingredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports